import whatsappChatConfig from './whatsappChatConfig';
import { AbstractChatProxyListener } from '../websocket/abstractChatProxyListener';
import { SupportedChatChannel } from '../supportedChatChannel';

export default class WhatsappChatListener extends AbstractChatProxyListener {
  constructor() {
    super(SupportedChatChannel.WHATSAPP, whatsappChatConfig);
  }
}
